import React from 'react';
import { useIntl } from 'react-intl';
import { states } from '@/constants/lifecycle';
import { commonNameAttributes, identifiableName } from '@/utils/resultsHelper';
import ArchivalDialogConfirmation, { validateArchivalForm } from './ArchivalDialogConfirmation';
import ActionDialogForm from './ActionDialogForm';
import ActionDialogItems from './ActionDialogItems';

const ArchivalDialogContent = ({
  children,
  className,
  entities,
  entity,
  hide,
  icon,
  identifiers = commonNameAttributes,
  items,
  modalIcon = 'archive',
  onArchive,
  reasonIsMandatory,
  simple,
  theme,
}) => {
  const intl = useIntl();
  const [confirmation, setConfirmation] = React.useState('');
  const [reason, setReason] = React.useState('');
  const [validationErrors, setValidationErrors] = React.useState([]);
  const name = identifiableName(items, identifiers);

  const confirmed = () => ((simple || items.length > 1)
    ? confirmation.toLowerCase() === intl.formatMessage({ id: 'actions.yes' }).toLowerCase()
    : confirmation === name);

  const saving = () => items.some((result) => result.destroyStatus === states.PENDING);

  const resetState = () => {
    setConfirmation('');
    setReason('');
    setValidationErrors([]);
  };

  const handleClose = () => {
    resetState();
    hide();
  };

  const checkForErrors = () => {
    const errors = validateArchivalForm(entity, reason, reasonIsMandatory, intl);
    setValidationErrors(errors);

    return errors;
  };

  const submitForm = () => {
    const errors = checkForErrors();

    if (errors.length === 0) {
      onArchive(items, reason);
      resetState();
    }
  };

  return (
    <ActionDialogForm
      action="archive"
      className={className}
      entity={entity}
      entities={entities}
      hide={hide}
      identifiers={identifiers}
      inProgress={items.some((result) => result.destroyStatus === states.PENDING)}
      items={items}
      modalIcon={modalIcon}
      onClick={submitForm}
      minimumDataEntryMet={confirmed()}
      onClose={handleClose}
      theme={theme}
    >
      <ArchivalDialogConfirmation
        confirmation={confirmation}
        disabled={saving()}
        entities={entities}
        entity={entity}
        items={items}
        minimumDataEntryMet={confirmed}
        onChangeConfirmation={setConfirmation}
        onChangeReason={setReason}
        reason={reason}
        submitForm={submitForm}
        validationErrors={validationErrors}
      />
      {items.length > 1 && (
        <ActionDialogItems action="archive" icon={icon} entities={entities}>
          {children}
        </ActionDialogItems>
      )}
    </ActionDialogForm>
  );
};

export default ArchivalDialogContent;
